
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2 3.333v9.334h12V3.333H2zm2.667 1.334V6H3.333V4.667h1.334zm-1.334 4V7.333h1.334v1.334H3.333zm0 1.333h1.334v1.333H3.333V10zm9.334 1.333H6V10h6.667v1.333zm0-2.666H6V7.333h6.667v1.334zm0-2.667H6V4.667h6.667V6z","fill":"currentColor"}})])
          )
        }
      }
    